<template ref="indexCase">
  <div style="background:#f5f2f5;padding-bottom: 1px;">
    <h1 class="u-h1" v-show="animateShow">
      <h2 class="cn animate__flipInY animate__animated animate__slow">成功案例</h2>
      <h4 class="en animate__fadeInUp animate__animated animate__slow">SUCCESSFUL CASE</h4>
    </h1>
    <ul class="m-case g-box" v-show="animateShow">
      <li class="case-li" v-for="(item,index) in caseList" :key="index" v-if="index < 6">
        <div class="imgBox animate__animated animate__slow" :class="{'animate__fadeInLeft':index < 3,'animate__fadeInRight':index >= 3}">
          <img class="img" :src="item.img" alt="" @click="jumpToHref(item.link)">
        </div>
        <p>
          <span class="text" @click="jumpToHref(item.link)">{{ item.title }}</span>
        </p>
      </li>
    </ul>
    <div class="u-more-btn" @click="jumpToHref($api.domainName + 'real_project.html')">更多案例</div>
  </div>
</template>
<script>
  export default {
    name       : 'index-case',
    components : {},
    props      : {
      caseList : {
        type    : Array,
        default : [],
      },
      animateShow : {
        type    : Boolean,
        default : false
      }
    },
    data(){
      return {};
    },
    computed   : {},
    created(){},
    methods    : {
      jumpToHref(url){
        if(url){
          location.href = url;
        }
      }
    },
  };
</script>
<style scoped lang="scss">
  @media screen and (max-width: 960px){
    .m-case{
      .case-li{
        margin-bottom: 10Px;
      }
    }
  }
  .m-case{
    display: flex;
    /*align-items: center;*/
    flex-wrap: wrap;
    .case-li{
      width: calc((100% - 20px) / 3);
      text-align: center;
      &:not(:nth-child(3n)){
        margin-right: 10Px;
      }
      .imgBox{
        width: 100%;
        height: 142px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .img{
        max-width: 100%;
        max-height: 100%;
        @extend %btn_base;
      }
      .text{
        line-height: 2;
        @extend %btn_base;
      }
    }
  }
</style>

